import { Component } from '@angular/core';
import { CmsBannerComponent, CmsService, LanguageService, PageType, SemanticPathService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, take } from 'rxjs';
import { tap } from "rxjs/operators";
import { EBResponsiveBannerData } from './eb-responsive-banner.interface';

@Component({
  selector: 'eb-responsive-banner',
  templateUrl: './eb-responsive-banner.component.html',
  styleUrls: ['./eb-responsive-banner.component.scss'],
  standalone: false
})
export class EBResponsiveBannerComponent {
  public routerLink: string | any[] | undefined;
  public externalUrl: string | undefined;
  public isExternalLink = false;
  public styleClasses: string | undefined;
  public isExternalUrlValid: boolean = true;

  constructor(
    protected languageService: LanguageService,
    protected componentData: CmsComponentData<EBResponsiveBannerData>,
    protected component: CmsComponentData<CmsBannerComponent>,
    protected urlService: SemanticPathService,
    protected cmsService: CmsService
  ) {}
  validateExternalUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url);
      return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
    } catch (e) {
      console.warn(`Invalid URL provided: ${url}`, e);
      return false;
    }
  }
  handleExternalLinkClick(url: string, event: Event): void {
    event.preventDefault();
    if (this.isExternalUrlValid) {
      window.open(url, '_blank');
    } else {
      alert("Invalid external URL. Please try again later.");
    }
  }
  ngOnInit(): void {
    this.languageService.getActive().subscribe((languageData) => {
      this.componentData.data$.pipe(take(1)).subscribe();
    });
  }

  getTarget(data: EBResponsiveBannerData): string | null {
    return (data.external === undefined && data.externalLink === undefined) ||
    data.external === 'true' ||
    data.external === true ||
    data.externalLink === 'true' ||
    data.externalLink === true
      ? '_blank'
      : null;
  }

  hasUrl(data: EBResponsiveBannerData): boolean {
    return data.urlLink && typeof data.urlLink === 'string' && data.urlLink !== '';
  }

  protected setRouterLink(data: CmsBannerComponent): void {
    this.routerLink = undefined;
    this.externalUrl = undefined;
    this.isExternalLink = false;
    if (data.urlLink) {
      const trimmedUrl = data.urlLink.trim();

      const isExternal = /^https?:\/\//.test(trimmedUrl) || (trimmedUrl.includes('.') && !trimmedUrl.startsWith('/'));

      if (isExternal) {
        this.isExternalLink = true;
        this.externalUrl = trimmedUrl;
        this.isExternalUrlValid = this.validateExternalUrl(trimmedUrl);
      } else {
        this.isExternalLink = false;
        this.externalUrl = undefined;
        if (trimmedUrl.startsWith('/')) {
          this.routerLink = [trimmedUrl];
        } else {
          this.routerLink = ["/" + trimmedUrl];
        }
      }
    } else if (data.contentPage) {
      this.isExternalLink = false;
      this.externalUrl = undefined;
      this.cmsService
        .getPage({
          id: data.contentPage,
          type: PageType.CONTENT_PAGE
        })
        .pipe(take(1))
        .subscribe(page => {
          this.routerLink = page?.label
        });
    } else if (data.product) {
      this.isExternalLink = false;
      this.externalUrl = undefined;
      this.routerLink = this.urlService.transform({
        cxRoute: 'product',
        params: {
          code: data.product,
          fullProductPath: 'product'
        }
      });
    } else if (data.category) {
      this.isExternalLink = false;
      this.externalUrl = undefined;
      this.routerLink = this.urlService.transform({
        cxRoute: 'category',
        params: { code: data.category }
      });
    }
  }
  protected data$: Observable<EBResponsiveBannerData> = this.component.data$.pipe(
    tap((data) => {
      this.setRouterLink(data);
      this.styleClasses = data.styleClasses;
    })
  );

}
